export const CATEGORIES = ["INSIGHT", "INCOTERMS", "DOGANE", "LOGISTICA", "MARKETS", "CONTRACTS"];

const EXTRA_LABELS = {
  MARKETS: { it: "Mercati", en: "Markets" },
  CONTRACTS: { it: "Contratti", en: "Contracts" },
  INSIGHT: { it: "Insight", en: "Insight" },
};

export const CATEGORY_PAGES = [
  {
    key: "INCOTERMS",
    slug: "incoterms",
    label: { it: "Incoterms", en: "Incoterms" },
    h1: { it: "Articoli su Incoterms", en: "Articles on Incoterms" },
    intro: {
      it: "Gli Incoterms 2020 definiscono chi risponde di trasporto, assicurazione, dogane e scarico in ogni vendita internazionale. Qui trovi guide pratiche per scegliere il termine giusto, allocare rischi e costi in modo consapevole ed evitare le ambiguità che costano caro.",
      en: "Incoterms 2020 define who is responsible for transport, insurance, customs and unloading in every international sale. Here you find practical guides to choose the right term, allocate risks and costs deliberately and avoid costly ambiguity.",
    },
    seo: {
      it: { title: "Articoli su Incoterms — LB Trade Advisory", desc: "Guide e approfondimenti sugli Incoterms 2020: scegliere il termine giusto, obblighi, costi e rischi tra venditore e acquirente." },
      en: { title: "Articles on Incoterms — LB Trade Advisory", desc: "Guides and insights on Incoterms 2020: choosing the right term, obligations, costs and risks between seller and buyer." },
    },
  },
  {
    key: "DOGANE",
    slug: "dogane",
    label: { it: "Dogane", en: "Customs" },
    h1: { it: "Articoli su dogane e dazi", en: "Articles on customs and duties" },
    intro: {
      it: "Codici HS, origine preferenziale, valore in dogana, dazi e procedure di sdoganamento: articoli e guide per attraversare le dogane senza ritardi, sfruttare gli accordi preferenziali e preparare la documentazione giusta.",
      en: "HS codes, preferential origin, customs value, duties and clearance procedures: articles and guides to cross borders without delays, make the most of trade agreements and prepare the right documentation.",
    },
    seo: {
      it: { title: "Dogane e dazi: articoli e guide — LB Trade Advisory", desc: "Articoli su dogane e dazi: classificazione doganale, origine preferenziale, valore in dogana e procedure di import-export." },
      en: { title: "Customs and duties: articles and guides — LB Trade Advisory", desc: "Articles on customs and duties: HS classification, preferential origin, customs value and import-export procedures." },
    },
  },
  {
    key: "LOGISTICA",
    slug: "logistica",
    label: { it: "Logistica", en: "Logistics" },
    h1: { it: "Articoli su logistica e spedizioni", en: "Articles on logistics and shipping" },
    intro: {
      it: "Spedizioni internazionali, scelta del vettore, assicurazioni cargo, documenti di trasporto e landed cost: gli approfondimenti per gestire la logistica internazionale in modo efficiente, senza sorprese sui costi.",
      en: "International shipments, carrier selection, cargo insurance, transport documents and landed cost: insights to manage international logistics efficiently, with no surprises on costs.",
    },
    seo: {
      it: { title: "Logistica e spedizioni internazionali: articoli — LB Trade Advisory", desc: "Articoli su logistica internazionale: spedizioni, vettori, assicurazioni cargo, documenti di trasporto e landed cost." },
      en: { title: "Logistics and international shipping: articles — LB Trade Advisory", desc: "Articles on international logistics: shipments, carriers, cargo insurance, transport documents and landed cost." },
    },
  },
];

export function categoryPageBySlug(slug) {
  return CATEGORY_PAGES.find((p) => p.slug === slug);
}

export function categoryPage(category) {
  return CATEGORY_PAGES.find((p) => p.key === category);
}

export function categoryLabel(category, lang) {
  return categoryPage(category)?.label[lang] || EXTRA_LABELS[category]?.[lang] || category;
}
